<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="直播名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {
        name: '',
      },
    };
  },
  props: {

  },
  created() {

  },
  methods: {

    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {
        name: '',
      };
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
